import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a463938"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "profile"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "profile__inner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Crumbs = _resolveComponent("Crumbs");
  const _component_Menu = _resolveComponent("Menu");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Crumbs, {
    class: "crumbs"
  }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_Menu), _createVNode(_component_router_view)])])]);
}